import React, { useState, useEffect, useCallback } from 'react';
import Login from './components/Login';
import ControlPanel from './components/ControlPanel';
import { getMessages } from './i18n';
import './App.css';

const getInitialTheme = () => {
  const stored = localStorage.getItem('theme');
  if (stored === 'light' || stored === 'dark') {
    return stored;
  }
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  }
  return 'dark';
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'ru');
  const [theme, setTheme] = useState(() => {
    const initial = getInitialTheme();
    if (typeof document !== 'undefined') {
      document.documentElement.dataset.theme = initial;
    }
    return initial;
  });
  const messages = getMessages(language);

  useEffect(() => {
    if (token) {
      setIsAuthenticated(true);
    }
  }, [token]);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('theme', theme);
  }, [theme]);

  const handleLogin = (token) => {
    localStorage.setItem('token', token);
    setToken(token);
    setIsAuthenticated(true);
  };

  const handleLogout = useCallback(() => {
    localStorage.removeItem('token');
    setToken('');
    setIsAuthenticated(false);
  }, []);

  const handleLanguageChange = (nextLanguage) => {
    localStorage.setItem('language', nextLanguage);
    setLanguage(nextLanguage);
  };

  const handleThemeToggle = () => {
    setTheme((current) => (current === 'dark' ? 'light' : 'dark'));
  };

  return (
    <div className="App">
      {!isAuthenticated ? (
        <Login
          onLogin={handleLogin}
          language={language}
          onLanguageChange={handleLanguageChange}
          messages={messages}
        />
      ) : (
        <ControlPanel
          token={token}
          onLogout={handleLogout}
          language={language}
          onLanguageChange={handleLanguageChange}
          theme={theme}
          onThemeToggle={handleThemeToggle}
          messages={messages}
        />
      )}
    </div>
  );
}

export default App;
